
define('eteration/widgets/ui-routerestrictionmessage',[
	'knockout',
	'bloodhound',
	'eteration/eteration-ajax',
	'eteration/eteration-i18n',
	'bootstrap.select'
], function(ko,Bloodhound,etrAjax,i18n) {
		
	ko.bindingHandlers.routerestrictionmessage = {
		update: function (element, valueAccessor) {
		  
			var $element = $(element);
			var accessor = valueAccessor();
			var from = ko.unwrap(accessor.from);
			var to = ko.unwrap(accessor.to);
			
			if (!(from && to)) {
				$element.html('');
				return;
			}
			
			etrAjax.get({
				app : 'app.ibs',
				service : '/booking/routerestrictionmessage',
				disableLoader : true,
				cache : true,
				data : {
					'origin' : from,
					'destination' : to
				},
				callback : function(response) {
					$element.html('');
					var msg = '';
					for (var i = 0; i < response.data.length; i++) {
						msg+='<i class="fa fa-exclamation-circle red fa-1x mr-10 pull-left"></i>';
						msg+='<div>'+i18n.get(response.data[i])+'</div>';
					}
					
					if(msg){
						$element.html('<div class="row" ><div class="col-xs-12 pb-15">' + msg + '</div></div>');						
					}
				}
			});	

		},
	};
});
